import {UI} from "../../../../stem-core/src/ui/UIBase";

import {styleRule} from "../../../../stem-core/src/decorators/Style";
import {Messages} from "../../../Messages";
import {UserPreferencesStore} from "../../../State";
import {MerchantCard, MerchantCardStyle} from "../../ui/MerchantCard";
import {WalletMerchantButton} from "../../../common/MerchantButton";
import {ExternalLink} from "../../ui/ExternalLink";
import {registerStyle, Theme} from "../../../../stem-core/src/ui/style/Theme";
import {LoadingWidget} from "../../ui/LoadingWidget";
import {MerchantPopup} from "../../ui/MerchantPopup";
import {Money} from "../../../../client/state/misc/Money";
import {ErrorBanner} from "../../ui/ErrorBanner";
import {userService} from "../../../../client/connection/Services";
import {WalletStore} from "../../../State";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {MessageElement} from "../../ui/MessageElement";
import {apiUpdateUserMerchantPreferences, MerchantUserStore} from "../../../../client/state/merchant/MerchantUserStore";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";


class ElementStyle extends MerchantCardStyle {
    @styleRule
    paragraph = {
        color: Theme.props.MERCHANT_AUTOPAY_TEXT_COLOR,
    };

    @styleRule
    infoLine = {
        marginBottom: 14,
    };
}

@registerStyle(ElementStyle)
class Element extends MerchantCard {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            getTitle: () => iFrameUserDataService.isAutoPayEnabled() ? Messages.manageAutopay : Messages.setupAutopay,
        };
    }

    isAutopayDefaultDisabled() {
        return !UserPreferencesStore.getPreferences().autoPayEnabled;
    }

    render() {
        const {styleSheet} = this;
        const articlePriceLimit = new Money(
            UserPreferencesStore.getPreferences().articlePriceLimit,
            WalletStore.getWallet().getCurrency()
        );
        const disabled = this.isAutopayDefaultDisabled();

        return [
            <MessageElement
                className={styleSheet.infoLine}
                message={disabled ? Messages.disabledAutopayInfo1
                    : Messages.autopayInfo1(iFrameMerchantService.getMerchant().getName(), articlePriceLimit)}/>,
            <div className={styleSheet.infoLine}>
                {disabled ? Messages.disabledAutopayInfo2 : Messages.autopayInfo2}
                <ExternalLink label={Messages.blinkDashboardTitle} href="/" />.
            </div>,
        ];
    }

    renderPrimaryButton() {
        return <WalletMerchantButton label={iFrameUserDataService.isAutoPayEnabled() ? Messages.disableAutopay : Messages.enableAutopay}
                               onClick={() => this.toggleAutopay()} disabled={this.isAutopayDefaultDisabled()}/>;
    }

    async toggleAutopay() {
        const merchant = iFrameMerchantService.getMerchant();
        try {
            await LoadingWidget.walletLoad(() => apiUpdateUserMerchantPreferences({
                userId: userService.getUserId(),
                merchantId: merchant.id,
                autoPayEnabled: !iFrameUserDataService.isAutoPayEnabled(),
            }));
        } catch (error) {
            if (error && error.message) {
                ErrorBanner.show(error.message);
            }
        } finally {
            this.discard();
        }
    }

    onMount() {
        super.onMount();

        this.attachChangeListener(UserPreferencesStore, () => this.redraw());
        this.attachChangeListener(MerchantUserStore, () => this.redraw());
    }
}

export const Autopay = MerchantPopup(Element);
